import { render, staticRenderFns } from "./DeleteEventModal.vue?vue&type=template&id=c310a640"
import script from "./DeleteEventModal.vue?vue&type=script&lang=js"
export * from "./DeleteEventModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteEventModal.vue?vue&type=style&index=0&id=c310a640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports